import React from "react";
import {
  Container,
  Column,
  Img,
  Link,
  Row,
  Section,
  Text,
  Tailwind,
} from "@react-email/components";
import withClipboard from "@/shared/copy-to-clipboard";

import SocialLinks from "./social-links";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

const EmailSignature1 = ({ id }) => {
  const user = useSelector(selectUser);

  return (
    <div id={id} className="bg-white p-4  rounded-sm">
      <Tailwind>
        <Container
          align="none"
          className="font-mono font-semibold border max-w-72 border-gray-500 border-solid"
        >
          <Section className="">
            <Row>
              <Column className="border-0 border-r border-r-gray-500 border-solid w-3/4 p-3">
                <Text className="text-base leading-none m-0 text-black">
                  {user.first_name} {user.last_name}
                </Text>
                <Text className="text-xs m-0 mt-1 text-black">
                  {user.secondary_job_title || user.job_title?.name}
                </Text>
              </Column>

              <Column>
                <Text className="text-2xl text-center leading-none text-white ">
                  {user?.emoji || "👋"}
                </Text>
              </Column>
            </Row>
          </Section>

          <Section className="border-t border-gray-500 border-solid text-sm ">
            <Row>
              <Column className="px-3 py-2">
                {user.phone_no ? (
                  <Link
                    className="  font-semibold"
                    href={`tel:${user.phone_no}`}
                  >
                    <Text className="text-black m-0">
                      {" "}
                      Call: {user.phone_no}
                    </Text>
                  </Link>
                ) : (
                  <Text className="m-0 text-black">
                    🚨 Mobile Number Missing
                  </Text>
                )}
              </Column>
            </Row>
          </Section>

          <SocialLinks user={user} />

          <Section className="border-t border-gray-500 border-solid">
            <Row>
              <Column className="py-4 text-center">
                <Img
                  className="h-12 inline-block"
                  src="https://products.7span.in/assets/f3d89878-d0c4-4c2f-bc73-bb2ccc715f4c"
                />
              </Column>
            </Row>
          </Section>

          <Section className="border-t border-gray-500 border-solid">
            <Row>
              <Column className="text-sm border-0 border-r border-r-gray-500 border-solid text-center">
                <Link
                  href={`https://7span.com/?utm_source=email&utm_medium=sign&utm_emp=${
                    user.email.split("@")[0]
                  }`}
                >
                  <Text className="m-0 py-2 px-3 leading-none text-black">
                    7span.com
                  </Text>
                </Link>
              </Column>
              <Column className="text-center">
                <Text className=" text-red-500 leading-none py-2 px-3 m-0">
                  Making IT Possible
                  {/* make it possible */}
                </Text>
              </Column>
            </Row>
          </Section>
        </Container>
      </Tailwind>
    </div>
  );
};

export default withClipboard(EmailSignature1);
